import React, { useEffect } from 'react';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useContext as useUsersContext } from 'components/Users/Context';

import { useContext } from './Context';

import Content from './Content';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();
  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
    actions.loadAvatar(dispatch);
    actions.getToken(dispatch);
  }, []);

  useEffect(() => {
    if (stateUsers.user && state.token) {
      actions.load(dispatch, state.token);
    }
  }, [stateUsers.user, state.token]);

  return (
    <div className="ai-full-page-chat-wrapper chat-messages-wrapper">
      {stateUsers.user === null
        || state.chats === null
        || state.avatar === null
        || state.token === null
        ? <LoadingPlaceholder text="Loading..." /> : <Content /> }
    </div>
  );
}
